export const UNSOLD_STAGE_KEYS = [
  'retargeting',
  'mid_term_nurturing',
  'long_term_nurturing',
  'very_long_term_nurturing',
] as const;

export const UNSOLD_STAGE_LABELS: Record<string, string> = {
  retargeting: 'Retargeting',
  mid_term_nurturing: 'Mid Term Nurturing',
  long_term_nurturing: 'Long Term Nurturing',
  very_long_term_nurturing: 'Very Long Term Nurturing',
};

// retargeting is the primary key; sold_nurturing supported for backward compatibility with existing API data
export const SOLD_STAGE_KEYS = ['retargeting', 'sold_nurturing'] as const;
export const SOLD_STAGE_LABELS: Record<string, string> = {
  retargeting: 'Retargeting',
  sold_nurturing: 'Retargeting', // legacy alias - display as Retargeting
};

export const STEP_TYPE_LABELS: Record<string, string> = {
  fixed: 'Fixed',
  value_associated_with_previous: 'Value Associated With Previous',
  alternate: 'Alternate',
};

export const CADENCE_UNIT_LABELS: Record<string, string> = {
  days: 'Days',
  months: 'Months',
  years: 'Years',
};

export const GENERATED_TEMPLATE_TYPE_OPTIONS = [
  { value: 'dynamic', label: 'Dynamic' },
  { value: 'static', label: 'Static' },
];

export const DSL_NAME_OPTIONS = [
  'VALUE_ASSOCIATED_WITH_PREVIOUS',
  'VALUE_ASSOCIATED_WITH_PREVIOUS_IF_NOT_SENT',
];

export const TEMPLATE_TYPE_OPTIONS = [
  'LEASE_VEHICLE',
  'FINANCE_VEHICLE',
  'NEW_VEHICLE',
  'USED_VEHICLE',
  'CPO_VEHICLE',
];
